/**
 * Standardised Firebase Authentication error handler.
 * Converts technical Firebase error codes and raw exception strings
 * into clear, friendly, human-readable user messages.
 */
export function getFriendlyAuthErrorMessage(error: any): string {
  if (!error) return 'An unexpected error occurred. Please try again.';

  const errStr = typeof error === 'string' ? error : error?.code || error?.message || '';

  if (errStr.includes('auth/email-already-in-use')) {
    return 'This email address is already registered.';
  }
  if (errStr.includes('auth/invalid-email')) {
    return 'Please enter a valid email address.';
  }
  if (errStr.includes('auth/weak-password')) {
    return 'Password must be at least 6 characters long.';
  }
  if (errStr.includes('auth/network-request-failed')) {
    return 'Unable to contact the server. Please check your internet connection.';
  }
  if (errStr.includes('auth/too-many-requests')) {
    return 'Too many attempts. Please try again in a few minutes.';
  }
  if (
    errStr.includes('auth/user-not-found') ||
    errStr.includes('auth/wrong-password') ||
    errStr.includes('auth/invalid-credential')
  ) {
    return 'Incorrect email address or password.';
  }
  if (errStr.includes('auth/user-disabled')) {
    return 'This account has been disabled.';
  }
  if (errStr.includes('auth/internal-error')) {
    return 'Something went wrong while processing the account. Please try again.';
  }

  // Sanitize any remaining raw "Firebase: Error (...)" prefix
  if (typeof error?.message === 'string') {
    if (error.message.startsWith('Firebase: Error') || error.message.includes('auth/')) {
      return 'An authentication error occurred. Please try again.';
    }
    return error.message;
  }

  return 'An unexpected error occurred. Please try again.';
}
